import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';

type AProps = ComponentPropsWithoutRef<'a'>;
type OverflowProps = { textOverflow?: boolean };
type Props = AProps & OverflowProps;

export const Anchor = forwardRef<HTMLAnchorElement, Props>((props, ref) => <Styled.Anchor {...props} ref={ref} />);

Anchor.displayName = 'Anchor';
